import axios from '@/services/axios'
import qs from 'qs'

export default {
  // 区域接口
  getAera(parm) {
    let apiConfig = ''
    if (
      Wiz.globalSettings.dynamicModules.modules &&
      Wiz.globalSettings.dynamicModules.modules['wiz-iot-management'] &&
      Wiz.globalSettings.dynamicModules.modules['wiz-iot-management'].config &&
      Wiz.globalSettings.dynamicModules.modules['wiz-iot-management'].config.devaspServer
    ) {
      apiConfig = Wiz.globalSettings.dynamicModules.modules['wiz-iot-management'].config.devaspServer
    }
    const basicUrl = Wiz.GetModuleServer('iot-device-management')
    if (!apiConfig.includes('?')) {
      apiConfig = `${apiConfig}?`
    }
    apiConfig = basicUrl + apiConfig
    return axios.get(`${apiConfig}${qs.stringify(parm)}`)
  },
}
